import { render, staticRenderFns } from "./ExhibitionBoard.vue?vue&type=template&id=0b66d0ff&scoped=true"
import script from "./ExhibitionBoard.vue?vue&type=script&lang=js"
export * from "./ExhibitionBoard.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionBoard.vue?vue&type=style&index=0&id=0b66d0ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66d0ff",
  null
  
)

export default component.exports